import { Global, css } from "@emotion/react";
import * as React from "react";

import { Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import PriorityIndicator from "components/priority/PriorityIndicator";
import { TICKET_PRIORITY_LABEL_MAP } from "constants/tickets/priorities";
import { TicketPriority } from "interfaces/entities/ticket";

interface IProps {
  priority: TicketPriority;
  fontSize?: string;
}

const PriorityLabel: React.FC<IProps> = ({ priority }) => (
  <>
    <Global
      styles={css`
        .lc-multiselect-head__item-content {
          ${Flex} {
            margin-left: -5px;
          }
        }
      `}
    />
    <Flex inline alignItems="baseline">
      <div style={{ alignSelf: "flex-end" }}>
        <PriorityIndicator priority={priority} />
      </div>
      <Text>{TICKET_PRIORITY_LABEL_MAP[priority]}</Text>
    </Flex>
  </>
);

export default PriorityLabel;
